import React from 'react';
import moment from 'moment';
import { FormatNumber2 } from '../utility/component/tools';
import '../utility/styles/print.css';

const getCompanyDetails = () => {
  try {
    return JSON.parse(localStorage.getItem('companyDetails')) || {};
  } catch (error) {
    return {};
  }
};

const PrintVoucherSummary = React.forwardRef((props, ref) => {
  const { data, firstDate, SecondDate, bookingCustomerDetails } = props;
  const company = getCompanyDetails();
  const companyName =
    company.companyName ||
    company.company_name ||
    localStorage.getItem('company') ||
    'Company';
  const companyAddress = [
    company.address,
    company.city,
    company.state,
    company.pinCode || company.pin_code || company.pincode,
  ]
    .filter(Boolean)
    .join(', ');
  const companyContact = [
    company.mobile && `Phone: ${company.mobile}`,
    company.email && `Email: ${company.email}`,
  ]
    .filter(Boolean)
    .join('  •  ');
  const customerFilter = [
    bookingCustomerDetails?.customer_name,
    bookingCustomerDetails?.mobile,
  ]
    .filter(Boolean)
    .join(' • ');
  const debitTotal = data.reduce(
    (total, row) => total + (Number(row.DEBIT) || 0),
    0
  );
  const creditTotal = data.reduce(
    (total, row) => total + (Number(row.CREDIT) || 0),
    0
  );

  return (
    <div
      ref={ref}
      id="voucher-summary-print"
      className="bill-summary-print"
    >
      <table className="bill-summary-print-table">
        <colgroup>
          {[6, 9, 14, 11, 20, 9, 9, 9, 6, 7].map(
            (columnWidth, index) => (
              <col key={index} style={{ width: `${columnWidth}%` }} />
            )
          )}
        </colgroup>
        <thead>
          <tr>
            <th colSpan="10" className="print-company-header">
              <div className="print-company-name">{companyName}</div>
              {companyAddress && (
                <div className="print-company-detail">{companyAddress}</div>
              )}
              {companyContact && (
                <div className="print-company-detail">{companyContact}</div>
              )}
              <div className="print-report-heading">
                <span>Voucher Summary</span>
                <span>
                  {moment(firstDate).format('DD MMM YYYY')} –{' '}
                  {moment(SecondDate).format('DD MMM YYYY')}
                </span>
              </div>
              <div className="print-report-meta">
                <span>{customerFilter || 'All customers'}</span>
                <span>{data.length} voucher(s)</span>
              </div>
            </th>
          </tr>
          <tr className="print-column-header">
            <th>Voucher No.</th>
            <th>Date</th>
            <th>Customer</th>
            <th>Mobile</th>
            <th>Description</th>
            <th>Debit</th>
            <th>Credit</th>
            <th>Pay Mode</th>
            <th>Card No.</th>
            <th>ePayment Bank</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={`${row.VOUCHER_NO}-${index}`}>
              <td className="print-center">{row.VOUCHER_NO || '—'}</td>
              <td className="print-center">
                {row.DATE ? moment(row.DATE).format('DD-MM-YYYY') : '—'}
              </td>
              <td>{row.CUSTOMER_NAME || '—'}</td>
              <td className="print-center">{row.MOBILE || '—'}</td>
              <td>{row.AMOUNT_DESC || '—'}</td>
              <td className="print-amount">
                ₹{FormatNumber2(Number(row.DEBIT) || 0)}
              </td>
              <td className="print-amount">
                ₹{FormatNumber2(Number(row.CREDIT) || 0)}
              </td>
              <td>{row.PAY_MODE || '—'}</td>
              <td>{row.CARD_NO || '—'}</td>
              <td>{row.EPAYMENT_BANK || '—'}</td>
            </tr>
          ))}
          <tr className="print-total-row">
            <td colSpan="5" className="print-total-label">
              Column Totals
            </td>
            <td className="print-amount">₹{FormatNumber2(debitTotal)}</td>
            <td className="print-amount print-net">
              ₹{FormatNumber2(creditTotal)}
            </td>
            <td colSpan="3"></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
});

export default PrintVoucherSummary;
